import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import axios from 'axios';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Set axios defaults
axios.defaults.baseURL = ''; // Don't add /api prefix to avoid double paths

// Log environment details to console (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('Environment:', process.env.NODE_ENV);
  console.log('API URL:', process.env.REACT_APP_API_URL || 'http://localhost:5000');
  console.log('Client URL:', process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000');
  console.log('Using proxy with direct paths (no baseURL prefix)');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
